<template>
  <div class="excel-import-wrapper">
    <div v-if="templateUrl">
      <vs-button :href="fullTemplateUrl" color="primary" type="border" icon="icon icon-download" icon-pack="feather" class="mb-2" :target="true">Download Template</vs-button>
    </div>
    <div class="excel-import">
      <input type="file" ref="fileInput" class="hidden" accept=".xlsx, .xls" @change="handleClick">
      <div @click="$refs.fileInput.click()" @drop="handleDrop" @dragover="handleDragover" @dragenter="handleDragover"
        class="px-8 py-16 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl">
        <div v-if="!file" class="grid place-items-center">
          <feather-icon icon="UploadCloudIcon" svgClasses="h-16 w-16 stroke-current text-grey" class="block" />
          <span>Drop Excel File or </span>
          <span class="font-medium text-primary" @click.stop="$refs.fileInput.click()">Browse</span>
        </div>
        <div v-else class="grid place-items-center">
          <svg xmlns="http://www.w3.org/2000/svg" style="height: 9rem; fill: #10793F;" viewBox="0 0 384 512"><path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"/></svg>
          <span>{{ file.name }}</span>
          <button type="button" @click.stop="$emit('input', null)"
            class="underline bg-transparent border-none outline-none text-blue-500 p-2">Remove File</button>
        </div>
      </div>
      <vs-button @click="handleUpload" v-if="file" class="w-full bg-primary mt-3" block type="submit">Submit</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'templateUrl'],

  computed: {
    file: {
      get() {
        return this.value
      },
      set(value) {
        return this.$emit('input', value)
      }
    },

    fullTemplateUrl() {
      return process.env.VUE_APP_API + this.templateUrl
    }
  },
  methods: {
    handleDragover(e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDrop(e) {
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'Only support uploading one file!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return
      }
      const rawFile = files[0] // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'Only supports upload .xlsx, .xls, .csv suffix files',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.storeFile(rawFile)
    },
    handleClick(e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'Only supports upload .xlsx, .xls, .csv suffix files',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.storeFile(rawFile)
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
    storeFile(file) {
      this.$refs['fileInput'].value = null // fix can't select the same excel file);
      this.file = file
    },
    handleUpload() {
      this.$emit('handleUpload')
    }

  }
}
</script>
